import { useQuery } from '@tanstack/react-query';

import {
  type DashboardTemplate,
  getDashboardTemplates,
} from '@/entities/dashboard-template';
import { Skeleton } from '@/shared/ui';

import { DashboardTemplateCard } from './dashboard-template-card';

type DashboardTemplateSectionProps = {
  onSelect: (template: DashboardTemplate) => void;
};

export const DashboardTemplateSection = ({
  onSelect,
}: DashboardTemplateSectionProps) => {
  const { data: templates, isLoading } = useQuery({
    queryKey: ['dashboard-template-i18n'],
    queryFn: getDashboardTemplates,
    staleTime: Infinity,
  });

  return (
    <section className="flex flex-col px-8 pb-10">
      <h2 className="text-base font-semibold">Create with a template</h2>
      <div className="h-3" />
      <div className="flex max-w-3xl flex-wrap gap-2">
        {isLoading ? (
          <>
            <Skeleton className="h-[130px] w-full rounded-md sm:w-[300px]" />
            <Skeleton className="h-[130px] w-full rounded-md sm:w-[300px]" />
          </>
        ) : (
          templates?.map((template) => (
            <DashboardTemplateCard
              key={template.id}
              template={template}
              onClick={onSelect}
            />
          ))
        )}
      </div>
    </section>
  );
};
